import { Button, Center, Text } from '@mantine/core';
import { closeAllModals, openModal } from '@mantine/modals';
import { useEffect } from 'react';
import { ChargebeeS } from '../../../Service/ChargebeeS';

// eslint-disable-next-line import/prefer-default-export
export const openUnpaidInvoicesModal = () =>
  openModal({
    title: (
      <Text weight="bolder" size="xl">
        Unbezahlte Rechnungen
      </Text>
    ),
    children: <UnpaidInvoicesModal />,
  });

const UnpaidInvoicesModal = () => (
  <>
    <Text>
      Dein Konto weist noch offene Rechnungen auf. Der ausstehende Betrag muss beglichen werden, bevor Du ein neues Abo
      abschließen kannst. Klick auf 'Jetzt bezahlen', dann auf 'Billing History' und 'Pay Now'.
    </Text>
    <Center mt="xl">
      <Button
        onClick={() => {
          closeAllModals();
          ChargebeeS.openPortal();
        }}
      >
        Jetzt bezahlen
      </Button>
    </Center>
  </>
);

export const openCancelSubscriptionModal = () =>
  openModal({
    children: <CancelSubscriptionModal />,
  });

const CancelSubscriptionModal = () => {
  useEffect(() => {
    const { hbspt }: any = window ?? { hbspt: null };
    if (hbspt) {
      hbspt.forms.create({
        region: 'eu1',
        portalId: '25589471',
        formId: '976f4bdc-2b16-4213-81ac-c50352dc0111',
        target: '#hubspotForm',
      });
    }
  }, []);

  return <div id="hubspotForm" style={{ marginTop: -10 }} />;
};
